import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import Login from './components/Login';
import Home from './components/Home';
import GlobalApiLoader from './components/GlobalApiLoader';

function App() {
  return (
    <LanguageProvider>
      <Router>
        <GlobalApiLoader />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/home/*" element={<Home />} />
          <Route path="/" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </LanguageProvider>
  );
}

export default App;

